export const mergeCases = {
    isOpen: false,
    loadingNotes: false,
    loadingMerging: false,
    loadingMergeableCases: false,
    mergingResult: false,
    activeProcessInstanceGuid: null,
    currentCaseRun: {},
    mergeableCaseRuns: [],
    activeNotes: [],
    cursorAPIContext: null
};
